<template>
  <div
    id="app"
    :class="[
      activeStyle ? 'dark' : 'bright',
      $route.name == 'home' || $route.name == 'area' || $route.name == 'securityHome'
        ? 'homeBg'
        : '',
      ['login', 'gapSticklogin', 'waterSystemlogin'].includes($route.name) ? 'loginBg' : '',
      $route.path.indexOf('visualize') != -1 ? 'visualizeBg' : '',
      $route.name == 'MonitoringWarning' ? 'spcialBg' : '',
      $route.path.indexOf('remoteControl') != -1 ? 'remoteControlBg' : '',
      [
        'droneVisualize',
        'visualizeWrj2',
        'fireStation',
        'spacerBar',
        'pumpMonitor',
        'waterSystem',
        'waterSystemHome'
      ].includes($route.name)
        ? 'commonVisualizeBg'
        : ''
    ]"
    :style="{
      paddingTop:
        noMenus.every(o => o != $route.name) && lv2Menu.length > 0 ? 64 + menu1H + 'px' : '64px'
    }"
  >
    <header v-if="noMenus.every(o => o != $route.name)">
      <h1 class="title" @click="$router.push({ name: 'home' })">
        <span class="nocolor">
          <img
            v-default-img
            :src="user.titleImg ? user.titleImg : '../static/logo.png'"
            height="32"
            alt=""
          />
          <p class="sysName">
            {{ user.sysName }}
            <span>{{ user.shortName }}</span>
            <em class="gif">
              <em></em>
              <i class="mask"></i>
            </em>
          </p>
        </span>
      </h1>
      <section class="user">
        <!-- <el-radio-group
          class="tabTheme"
          v-model="theme"
          @change="changeTheme"
          size="mini"
        >
          <el-radio-button label="blue">经典蓝色</el-radio-button>
          <el-radio-button label="white">简约白色</el-radio-button>
        </el-radio-group> -->
        <el-popover placement="bottom" width="350" trigger="click" class="myselfPopover">
          <div class="container">
            <header>
              <span>
                <i class="iconfont iconxiaoxi"></i>
                告警消息
              </span>
              <span
                style="color: #31a1db; cursor: default"
                @click="$router.push('/management/allManagement/alarm/alarmSystem/alarm/relaAlarm')"
                >查看更多</span
              >
            </header>
            <ul class="wz" v-if="gzlist.length">
              <li
                v-for="(i, index) of gzlist"
                :key="index"
                @click="$router.push('/management/allManagement/alarm/alarmSystem/alarm/relaAlarm')"
              >
                <span>{{ i.msg }}</span>
                <span style="color: #31a1db; cursor: default">请前往查看</span>
              </li>
            </ul>
            <div class="withoutmsg wz" v-else>
              <span>无消息</span>
            </div>
          </div>
          <el-badge :value="gzlist.length" class="item" slot="reference">
            <i class="iconfont iconxiaoxi"></i>
          </el-badge>
        </el-popover>
        <span class="userIcon">
          <i class="iconfont iconuser"></i>
        </span>
        <el-dropdown @command="operation">
          <span class="username">
            {{ user.name }}
            <i class="el-icon-caret-bottom el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
            <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
            <!-- el-dropdown-item command="changeStyle">换肤</el-dropdown-item -->
          </el-dropdown-menu>
        </el-dropdown>
      </section>
      <ul class="tabs">
        <li
          :key="name"
          :class="{ active: i == index }"
          @click="push(name, path, i)"
          v-for="({ title, name, path, meta }, i) in menu"
          v-show="!(meta.show === false)"
          :style="cursor"
        >
          <span>{{ title }}</span>
        </li>
      </ul>
    </header>
    <menu1
      :menu="lv2Menu"
      id="menu1"
      v-if="noMenus.every(o => o != $route.name) && lv2Menu.length > 0"
      ref="menu1"
      @computedMenu1H="computedMenu1Height"
    ></menu1>
    <div class="page1">
      <keep-alive include="home">
        <router-view />
      </keep-alive>
    </div>
    <!-- 告警弹框 -->
    <el-dialog
      title="设备告警通知"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      id="websocketDialog"
      class="websocketDialog"
      @close="closeDialog"
    >
      <!-- 上边框矩形 -->
      <svg class="icon top" viewBox="0 0 12135 1024" t="1587006785991" p-id="3772" version="1.1">
        <path fill="#e94955" d="M 89.8964 0 h 12045.5 l -1024 1024 h -9916.63 Z" p-id="3773" />
      </svg>
      <!-- 上边框矩形 -->
      <svg class="icon bottom" viewBox="0 0 12135 1024" t="1587006785991" p-id="3772" version="1.1">
        <path fill="#e94955" d="M 89.8964 0 h 12045.5 l -1024 1024 h -9916.63 Z" p-id="3773" />
      </svg>
      <!-- 右边框 -->
      <div class="rightBorder">
        <svg class="icon right" viewBox="0 0 1024 1024" t="1587007090684" p-id="3906" version="1.1">
          <path fill="#e94955" d="M 468.47 1024 V 0 l 87.0595 87.0595 V 930.088 Z" p-id="3907" />
        </svg>
      </div>
      <!-- 左边框 -->
      <div class="leftBorder">
        <svg class="icon left" viewBox="0 0 1024 1024" t="1587007090684" p-id="3906" version="1.1">
          <path fill="#e94955" d="M 468.47 1024 V 0 l 87.0595 87.0595 V 930.088 Z" p-id="3907" />
        </svg>
      </div>
      <section class="topLines">
        <i class="line1"></i>
        <i class="line2"></i>
        <i class="line3"></i>
        <i class="part"></i>
        <span>
          <svg class="icon" viewBox="0 0 1024 1024" t="1587020372950" p-id="5885" version="1.1">
            <path
              fill="#f94757"
              d="M 512.701 1.803 c -281.606 0 -509.898 228.292 -509.898 509.9 c 0 281.611 228.292 509.903 509.898 509.903 c 281.613 0 509.901 -228.292 509.901 -509.903 c 0.001 -281.607 -228.288 -509.9 -509.901 -509.9 Z m 51.992 825.784 c 0 30.475 -24.763 55.06 -55.061 55.06 a 55.087 55.087 0 0 1 -38.957 -16.101 c -9.872 -10.048 -16.103 -23.727 -16.103 -38.959 v -40.171 c 0 -30.474 24.761 -55.063 55.06 -55.063 c 30.476 0 55.061 24.76 55.061 55.063 v 40.171 Z m 0 -469.415 v 259.207 c 0 30.476 -24.763 55.064 -55.061 55.064 a 55.082 55.082 0 0 1 -38.957 -16.105 c -9.872 -10.04 -16.103 -23.721 -16.103 -38.959 V 261.556 c 0 -30.48 24.761 -55.064 55.06 -55.064 c 30.476 0 55.061 24.762 55.061 55.064 v 96.616 Z"
              p-id="5886"
            />
          </svg>
          设备告警
        </span>
      </section>
      <div class="mainBox">
        <div class="leftMap">
          <div class="topBox" :style="{ height: guideVideo ? '72%' : '100%' }">
            <!-- 平面图 -->
            <displayb
              v-if="areaModel == 1 && dialogVisible"
              :rootData="rootData"
              :deviceId="deviceId"
              :resultMsg="resultMsg"
              :imgUrl="propImg"
              :upload="1"
              @showVideo="showVideo"
            />
            <!-- 地图 -->
            <mp v-else-if="areaModel != 1 && dialogVisible" :data="rootData" />
          </div>
          <div v-if="guideVideo" class="bottomBox">
            <!-- TODO 待填充 -->
          </div>
        </div>
        <div class="rightMsg">
          <section class="message">
            <span class="msg">
              <span>{{ alarmTime }}</span>
              <span style="color: #f94757">{{ alarmMsg }}</span>
              <span>请立即前往查看！</span>
            </span>

            <span class="op">
              <div style="color: #36bfff; cursor: default" class="ckdt chuli">
                &emsp;联系人：{{ sockUserName || '暂无' }}
              </div>
              <div style="color: #36bfff; cursor: default" class="chuli">
                联系电话：{{ phone || '暂无' }}
              </div>
            </span>
            <div class="msg_handle">
              <span @click="toSilence">消音</span>
              <!-- <span @click="tslxVisible=true">逃生路线</span> -->
              <span v-if="!showFire" @click="receiveAlarmNotice">领取</span>
              <span v-if="!showFire" @click="misInformation">确认误报</span>

              <span v-if="showFire" @click="startFire">开启灭火</span>
              <span v-if="showFire" @click="stopFire">停止灭火</span>
            </div>
          </section>
          <section v-if="showType" class="monitor" v-loading="loading">
            <VideoPlayer :videoUrl="videoUrl" v-if="videoUrl"></VideoPlayer>
            <!-- <span v-else>暂无摄像头信息</span> -->
            <span v-else>
              <img
                v-default-img
                v-if="img_Url"
                :src="img_Url"
                style="width: 100%; height: 100%"
                alt=""
            /></span>
          </section>
          <section
            v-else
            class="monitor"
            style="
              height: 150px;
              margin-top: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
            v-loading="loading"
          >
            <img
              v-default-img
              v-if="imgUrl"
              :src="imgUrl"
              style="width: 100%; height: 100%"
              alt=""
            />
            <span v-else>暂无摄像头信息</span>
          </section>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="逃生路线" :visible.sync="tslxVisible" @close="tslxVisible == false">
      <div class="tslx"></div>
    </el-dialog>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import { obj2urlsp } from 'utils'
  import VideoPlayer from './components/public/surveillance/video'
  export default {
    name: 'App',
    data() {
      return {
        // 换肤
        activeStyle: true,
        guideVideo: false,
        rootData: [],
        deviceId: 0,
        areaModel: '',
        resultMsg: [],
        propImg: '',
        sockUserName: '',
        phone: '',
        imgUrl: '',
        img_Url: '',
        videoUrl: '',
        showType: true,
        showFire: false,
        loading: false,
        user2: '',
        noMenus: [
          'login',
          'gapSticklogin',
          'waterSystemlogin',
          'admin',
          'changePsw',
          'loading',
          'demo',
          'visualizeHome',
          'visualizeDqhz',
          'visualizeSbgk',
          'accessLogin',
          'fireStation',
          'visualizeWrj',
          'visualizeWrj2',
          'spacerBar',
          'pumpMonitor',
          'waterSystem',
          'waterSystemHome'
        ],
        index: 0,
        gzlist: [],
        dialogVisible: false,
        tslxVisible: false,
        websock: null, //建立的连接
        lockReconnect: false, //是否真正建立连接
        timeout: 30 * 1000, //30秒一次心跳
        timeoutObj: null, //心跳心跳倒计时
        serverTimeoutObj: null, //心跳倒计时
        timeoutnum: null, //断开 重连倒计时
        alarmMsg: '', //告警内容
        alarmTime: '', //告警时间
        alarmId: '', //告警信息id
        menu1H: 0,
        recordOldValue: {
          height: ''
        },
        videoStart: false,
        sendNew: [],
        socketMsg: {},
        theme: '',
        lastTime: '',
        cursor: 'cursor:wait;pointer-events:none',
        audio: null,
        synth: null,
        speak: null
      }
    },
    computed: {
      ...mapState(['menu', 'user', 'loginSuper', 'historyAlarm']),
      lv2Menu() {
        if (!(this.menu && this.menu.length > 0)) {
          return []
        } else {
          return this.menu[this.index].children
        }
      }
    },

    components: {
      menu1: () => import('public/menu1'),
      mp: () => import('../src/components/public/mapDialog/index.vue'),
      displayb: () => import('public/builds/displays.vue'),
      VideoPlayer
    },
    methods: {
      // 获取一级菜单高度
      computedMenu1Height() {
        this.menu1H = this.$refs['menu1'].$el.offsetHeight
      },
      // 点击
      showVideo(val) {
        this.videoUrl = ''
        setTimeout(() => {
          this.videoUrl = val
        }, 10)
      },
      ...mapMutations(['changeTheme']),
      fon() {
        this.$router.push({
          path: `/appMonitor/${this.socketMsg.fireWarning}/${this.socketMsg.fireWarning}`,
          query: {
            itemId: this.socketMsg.itemId,
            id: this.socketMsg.areaId
          }
        })

        this.$nextTick(() => {
          this.dialogVisible = false
        })
      },
      foo() {
        this.dialogVisible = false

        // if (
        //   this.socketMsg.fireWarning == "electromobile" &&
        //   this.$route.path != "appMonitor/electromobile/electromobile"
        // ) {
        //   this.$router.push("appMonitor/electromobile/electromobile");
        //   return;
        // }

        // if (
        //   this.$route.path ==
        //   "/management/allManagement/alarm/alarmSystem/alarm/relaAlarm"
        // ) {
        //   return;
        // }

        this.$router.push('/management/allManagement/alarm/alarmSystem/alarm/relaAlarm')
      },
      push(name, path, i) {
        let that = this
        that.cursor = 'pointer-events:none'
        setTimeout(() => {
          this.cursor = 'pointer-events:auto'
        }, 1000)
        function mainPush() {
          that.index = i
          let pathes = path

          if (name === 'appMonitor' && that.menu && that.menu.length) {
            that.menu[i].children.forEach(e => {
              if (localStorage.getItem('sendNew')) {
                JSON.parse(localStorage.getItem('sendNew')).forEach(ele => {
                  if (e.name === ele.name && ele.title != -1) {
                    e.title = ele.title
                  }
                })
              }
            })
          }

          function firstPath(children) {
            pathes += '/' + children.path
            if (children.children.length > 0) firstPath(children.children[0])
          }
          if (that.lv2Menu.length > 0) firstPath(that.lv2Menu[0])
          that.$router.push({
            path: pathes
          })
        }
        if (new Date() - that.lastTime >= 0) {
          mainPush()
        } else {
          this.$message.warning('请勿频繁切换')
        }
        that.lastTime = new Date()
      },
      operation(command) {
        this[command]()
      },
      changePassword() {
        this.$router.push({
          path: '/changePsw'
        })
      },
      loginOut() {
        this.$store.commit('loginOut')
        sessionStorage.removeItem('alarmList')
        location.reload()
      },
      changeStyle() {
        this.activeStyle = !this.activeStyle
      },
      findAreaALLSuper() {
        let chat = this
        this.$axiosget('operation/area/selectArea').then(res => {
          chat.$root.areaALL = JSON.stringify(res.data.data)
        })
      },
      /******** websocket ********/
      // 初始化
      initWebSocket() {
        if (
          !localStorage.getItem('token') ||
          !localStorage.getItem('userphone') ||
          !localStorage.getItem('companyId')
        ) {
          return
        }
        let a = localStorage.getItem('userphone')
        let b = localStorage.getItem('companyId')
        const wsUri =
          process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true'
            ? `wss://${window.location.host}${process.env.API_HOST}socket/${a}/${b}`
            : `ws://${window.location.host}${process.env.API_HOST}socket/${a}/${b}`
        // 建立连接
        this.websock = new WebSocket(wsUri)
        // 连接成功
        this.websock.onopen = this.websocketOnOpen
        // 连接错误
        this.websock.onerror = this.websocketOnError
        // 接收信息
        this.websock.onmessage = this.websocketOnMessage
        // 连接关闭
        this.websock.onclose = this.websocketClose

        this.findAreaALLSuper()
      },
      // 开启心跳
      start() {
        let self = this
        self.timeoutObj && clearInterval(self.timeoutObj)
        self.timeoutObj = setInterval(() => {
          // 这里发送一个心跳，后端收到后，返回一个心跳消息
          // 如果连接正常
          self.websock.send('连接成功消息')
        }, self.timeout)
      },
      // 重连
      reconnect() {
        let that = this
        if (that.lockReconnect) {
          return
        }
        that.lockReconnect = true
        // 没连接上会一直重连，设置延迟避免请求过多
        that.timeoutnum && clearTimeout(that.timeoutnum)
        that.timeoutnum = setTimeout(() => {
          // 新连接
          that.initWebSocket()
          that.lockReconnect = false
        }, 5000)
      },
      // 重置心跳
      reset() {
        let that = this
        // 清除时间
        clearInterval(that.timeoutObj)
        // 重启心跳
        that.start()
      },
      websocketOnOpen() {
        // 连接成功事件
        console.log('WebSocket连接成功!')
        // 开启心跳
        this.start()
      },
      websocketOnError(e) {
        // 连接失败事件
        console.log('WebSocket连接发生错误', e)
      },
      websocketOnMessage(event) {
        // 接收服务器推送的信息
        let receiveMsg = JSON.parse(event.data)
        this.socketMsg = receiveMsg
        // 判断是否是当前登录公司告警
        if (receiveMsg && receiveMsg.companyId * 1 === localStorage.getItem('companyId') * 1) {
          // 清空之前数据
          this.dialogVisible = false
          this.rootData = []
          this.propImg = ''
          this.showFire = false
          if (this.gzlist.length !== 0) {
            let indexof
            let o = this.gzlist.find(i => i.alarmId == receiveMsg.alarmId)
            o
              ? (indexof = this.gzlist.indexOf(o)) && this.gzlist.splice(indexof, 1, receiveMsg)
              : this.gzlist.push(receiveMsg)
          } else {
            this.gzlist.push(receiveMsg)
          }
          this.$store.commit('SET_History_Alarm', this.gzlist)
          // sessionStorage.setItem('alarmList', JSON.stringify(this.gzlist))
          this.alarmTime = receiveMsg.releaseTime
          this.alarmMsg = receiveMsg.msg
          // 是否存在问题？
          this.rootData = receiveMsg.areas
            ? receiveMsg.areas.filter(it => it.model === receiveMsg.areaModel)
            : []
          this.areaModel = receiveMsg.areaModel
          this.resultMsg = []
          this.deviceId = receiveMsg.deviceIdL
          this.rootData.forEach(i => {
            this.resultMsg.push(i.areaParameter)
          })
          this.propImg = receiveMsg.planePicUrl
          this.phone = receiveMsg.phone
          this.sockUserName = receiveMsg.userName

          // 先暂停之前的
          try {
            this.audio.pause()
            this.synth.pause()
          } catch (e) {
            // ignored
          }
          this.synth = null
          this.speak = null
          // 播放提示音及语音播报
          new Promise((resolve, reject) => {
            try {
              this.audio.load()
              this.audio.addEventListener('canplaythrough', ev => {
                try {
                  console.log(this.audio, '播放正常')
                  this.audio.play()
                } catch (e) {
                  console.log('语音播放失败', e)
                  //TODO handle the exception
                }
              })
            } catch (e) {
              console.error('告警提示音播放失败！', e)
            }
            resolve()
          }).then(() => {
            console.warn(receiveMsg.msg)
            this.synth = this.synth || window.speechSynthesis
            this.speaker = this.speaker || new SpeechSynthesisUtterance()
            this.speaker.lang = 'zh-CN'
            this.speaker.text = receiveMsg.msg
            setTimeout(() => {
              try {
                this.audio.pause()
                this.synth.cancel()
                let count = 0
                while (this.dialogVisible && this.synth && count < 99) {
                  this.synth.speak(this.speaker)
                  // 无需删除，控制执行流程
                  count++
                }
              } catch (e) {
                console.error('语音播报告警失败！', e)
              }
            }, 3000)
          })
          this.$axiosget('operation/deviceAlarmApi/getAlarmImageByDeviceId', {
            params: {
              id: this.socketMsg.deviceIdL
            }
          }).then(res => {
            console.log(res)
            this.img_Url = res.data.data ? process.env.API_HOST + res.data.data : ''
            console.log(this.img_Url, '----')
          })
          // 查询摄像头资源
          this.$axiosget('operation/configuration/findByAreaId', {
            params: {
              AreaId: this.socketMsg.areaId
            }
          }).then(res => {
            this.$nextTick(() => {
              this.dialogVisible = true
              if (res.data.data.type == '2') {
                this.imgUrl = res.data.data.imgUrl
                this.showType = false
              } else {
                this.showType = true
                this.getVideoSource(receiveMsg.areaId)
              }
            })
          })
          // 收到服务器信息，心跳重置
          this.reset()
          // 如果设备是指定设备，则显示 灭火按钮
          if (receiveMsg.deviceName == '火警烟感864530055577697') {
            this.showFire = true
            this.startFire()
          }
        }
      },
      websocketClose(e) {
        // 连接关闭事件
        console.log('连接已关闭', e)
        if (!this.$store.state.startSocket) return
        // 重连
        this.reconnect()
      },
      /******** websocket ********/

      // 消音
      toSilence() {
        try {
          this.audio.pause()
          this.synth.pause()
        } catch (e) {
          // ignored
        }
        this.synth = null
        this.speak = null
        this.closeAllVideo()
      },
      // 领取告警
      receiveAlarmNotice() {
        let url = 'operation/deviceAlarmApi/pickupAlarm'
        let id = this.socketMsg.alarmId
        this.$axiospost(url, obj2urlsp({ id: id, userId: this.$store.state.user.phone })).then(
          res => {
            if (res.data.status === '10000' || res.data.status === 10000) {
              this.$message.success('领取成功！')
            }
          }
        )
        this.dialogVisible = false
        this.closeAllVideo()
      },
      // 确认误报
      misInformation() {
        let url = 'operation/deviceAlarmApi/quickHandleAlarm'
        let id = this.socketMsg.alarmId
        this.$axiospost(
          url,
          obj2urlsp({
            id: id,
            userId: this.$store.state.user.phone,
            processReason: '确认误报',
            processResult: '确认误报'
          })
        ).then(res => {
          if (res.data.status === '10000' || res.data.status === 10000) {
            this.$message.success('处理成功！')
            this.dialogVisible = false
          } else {
            this.$message.warning(res.data.message || '系统异常！')
          }
        })
        this.closeAllVideo()
      },
      // 开启灭火
      startFire() {
        console.log('开启灭火')

        let obj = {
          deviceId: '867394042719999',
          deviceType: '189',
          serviceName: 'DHMCYCLE',
          serviceType: 'DHMCYCLE',
          type: 0,
          domains: [
            {
              value: '1',
              valueName: 'cycle'
            }
          ]
        }

        this.$axiospost('operation/command/add', obj).then(res => {
          this.$message.success('开启灭火')
        })
      },
      // 停止灭火
      stopFire() {
        console.log('停止灭火')
        let obj = {
          deviceId: '867394042719999',
          deviceType: '189',
          serviceName: 'DHMCYCLE',
          serviceType: 'DHMCYCLE',
          type: 0,
          domains: [
            {
              value: '0',
              valueName: 'cycle'
            }
          ]
        }

        this.$axiospost('operation/command/add', obj).then(res => {
          this.$message.success('停止灭火')
        })
      },
      // 获取视频资源
      getVideoSource(val) {
        let that = this
        that
          .$axiosget('operation/configuration/findByAreaId', {
            params: {
              AreaId: val || that.socketMsg.areaId
            }
          })
          .then(res => {
            setTimeout(() => {
              that.videoUrl = res.data.data.url ? res.data.data.url : res.data.data.video_url
              that.loading = false
            }, 1000)
          })
      },
      // 暂停所以视频
      closeAllVideo() {
        try {
          let videoNode = document.getElementsByTagName('video')
          if (videoNode && videoNode.length) {
            for (let i = 0; i < videoNode.length; i++) {
              videoNode[i].pause()
            }
          }
        } catch (e) {
          // ignored
        }
      },
      // 关闭告警框
      closeDialog() {
        try {
          this.audio.pause()
          this.synth.pause()
        } catch (e) {
          // ignored
        }
        this.synth = null
        this.speaker = null
        this.videoUrl = ''
        this.dialogVisible = false
      },
      // 关闭浏览器清空本地存储
      beforeunloadHandler(e) {
        this._beforeUnload_time = new Date().getTime()
      },
      unloadHandler(e) {
        this._gap_time = new Date().getTime() - this._beforeUnload_time
        //判断是窗口关闭还是刷新
        if (this._gap_time <= 5) {
          localStorage.removeItem('companyId')
          localStorage.removeItem('user')
          localStorage.removeItem('loginSuper')
          localStorage.removeItem('username')
          localStorage.removeItem('token')
          localStorage.removeItem('userId')
          localStorage.removeItem('userphone')
        }
      }
    },
    watch: {
      $route: {
        handler: function(n, o) {
          if (this.menu && this.menu.length) {
            this.menu.forEach((m, i) => {
              const name = m.name || 'undefined'
              if (n.path.indexOf(name) > -1) {
                this.index = i
                if (name === 'appMonitor' && m.children && localStorage.getItem('sendNew')) {
                  let renameMenuList = JSON.parse(localStorage.getItem('sendNew')).filter(
                    it => it.title !== '-1' && it.title !== -1
                  )
                  m.children.forEach(e => {
                    let rn = renameMenuList.find(
                      ele => e.name + 'System' === ele.name || e.name === ele.name
                    )
                    if (rn) e.title = rn.title
                    // renameMenuList.forEach(ele => {
                    //   if (e.name + 'System' === ele.name || e.name === ele.name) {
                    //     e.title = ele.title
                    //   }
                    // })
                  })
                  // 刷新会导致失效
                  // localStorage.removeItem('sendNew')
                }
              }
            })
          }
        },
        immediate: true
      },

      '$store.state.startSocket': function(value) {
        value ? this.initWebSocket(1) : this.websocketClose()
      }
    },
    mounted() {
      // 关闭浏览器清空本地存储
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
      window.addEventListener('unload', e => this.unloadHandler(e))
      // if (
      //   JSON.parse(sessionStorage.getItem('alarmList')) &&
      //   JSON.parse(sessionStorage.getItem('alarmList')).length != 0
      // ) {
      //   this.gzlist = JSON.parse(sessionStorage.getItem('alarmList'))
      // }
      this.audio = new Audio('../static/minorAlarm.mp3?rd=' + new Date().getTime())
      this.gzlist = this.historyAlarm

      JSON.parse(sessionStorage.getItem('startSocket'))
        ? this.initWebSocket()
        : this.websocketClose()

      document.querySelector('body').addEventListener('click', e => {
        this.videoStart = true
      })
      setTimeout(() => {
        this.cursor = 'cursor:pointer;pointer-events:auto'
      }, 1000)
    },
    created() {
      this.theme = this.$store.state.theme
      let _ = require('lodash')
      window._ = _
      let keyboard = require('utils').keyboard
      window.keyboard = keyboard
      this.cursor = 'pointer-events:none'
    },
    destroyed() {
      // 关闭浏览器清空本地存储
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
      window.removeEventListener('unload', e => this.unloadHandler(e))
      // 页面销毁时关闭长连接
      this.websocketClose()
      clearInterval(this.timeoutObj)
    }
  }
</script>

<style lang="less">
  html {
    @media (max-width: 850px) {
      font-size: calc(850px * 100 / 1920);
    }
    @media (min-width: 850px) {
      font-size: calc(100vw * 100 / 1920);
    }
  }

  body {
    font-size: 0.14rem;
  }
  @import '../static/css/public.less';
  @import '../static/css/default-style.less';
  @import '../static/css/bright-style.less';
  #app {
    overflow: hidden;
    width: 100%;
    height: 100%;
    font-family: 'Microsoft YaHei', 'SF Pro Display', Roboto, Noto, Arial, 'PingFang SC', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #0e0e18;
    position: relative;
    // 滚动条
    ::-webkit-scrollbar {
      overflow: scroll;
      width: 0px;
    }
    &.homeBg {
      background: url(../static/bg.jpg);
      background-size: cover;
      background-color: transparent;

      > header {
        background-color: transparent;
        border-bottom: 1px solid #3b4c75;
      }

      .tabs li:hover,
      .tabs li.active {
        background: url(../static/light.png) no-repeat top center;
        background-size: 100%;
      }
    }

    &.spcialBg {
      background-color: #0a1c2c;
    }

    &.loginBg {
      padding-top: 0 !important;
      background: url(../static/loginBg.jpg);
      background-size: cover;
      background-color: transparent;
    }

    &.visualizeBg {
      padding-top: 0 !important;

      .page1 {
        padding: 0;
      }
    }

    &.remoteControlBg {
      .page1 {
        padding: 0;
        overflow: hidden;
      }
    }

    &.commonVisualizeBg {
      padding-top: 0 !important;

      .page1 {
        padding: 0;
        overflow: hidden;
      }
    }
  }

  #app > header {
    width: 100%;
    height: 64px;
    line-height: 64px;
    background: #181c2e;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
  }

  #app > header h1 {
    font-size: 16px;
    padding-left: 38px;
    display: inline-block;
    line-height: 64px;
    height: 64px;
  }

  #app > header svg {
    width: 60px;
    height: 64px;
    float: left;
  }

  .color {
    fill: url(#SVGID_1_);
  }

  .nocolor {
    color: #fff;

    .sysName {
      line-height: 32px;
      display: inline-block;
      height: 32px;
      font-size: 20px;
      color: #fff;
      position: relative;
      letter-spacing: 1px;
      margin-left: 10px;
    }

    .gif {
      position: absolute;
      bottom: -3px;
      left: 0;
      width: 100%;
      height: 6px;
      background: linear-gradient(to right, #46ceff, rgba(255, 255, 255, 0));

      em {
        position: absolute;
        top: -2px;
        left: 0;
        width: 3px;
        height: 10px;
        background: #46ceff;
      }

      i {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 6px;
        animation: changeWidth 6s infinite;
        background: #181c2e;
      }
    }

    @keyframes changeWidth {
      0% {
        width: 90%;
      }

      50% {
        width: 0;
      }

      100% {
        width: 90%;
      }
    }

    span {
      padding: 0 10px;
      background: #2e3657;
      color: #00bfff;
      height: initial;
      line-height: initial;
      font-size: 14px;
      position: relative;
      top: -2px;
    }
  }

  .user {
    float: right;
    height: 36px;
    line-height: 36px;
    display: flex;
    padding-right: 20px;
  }

  .user .el-badge {
    display: inline-block;
    margin-top: 14px;
    margin-right: 10px;
    position: relative;
  }

  .user .el-badge i {
    font-size: 26px;
    color: #8493ba;
  }

  .user .el-badge .el-badge__content {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 2px;
    transform: scale(0.9);
    border: none;
  }

  .userIcon {
    width: 36px;
    height: 36px;
    display: inline-block;
    margin-top: 14px;
    border-radius: 100%;
    background: #404c6a;
    margin-right: 10px;
    position: relative;
  }

  .userIcon i {
    font-size: 18px;
    color: #8493ba;
    height: 18px;
    line-height: 1;
    position: absolute;
    top: 9px;
    left: 9px;
  }

  .username {
    line-height: 64px;
    flex: 1;
    font-size: 14px;
    color: #cccccc;
  }

  .icondown {
    font-size: 14px;
    color: #36bfff;
    margin-left: 10px;
  }

  .el-popover {
    background-color: rgba(33, 50, 86, 0.9);
    border: none;
    color: #fff;
    padding: 0;
    box-shadow: 0 0 30px 10px #2a4d7c inset;
  }

  .el-popover[x-placement^='bottom'] .popper__arrow {
    border-bottom-color: #2a4d7c;

    &::after {
      border-bottom-color: #2a4d7c;
    }
  }

  .el-popover .container header {
    // background-color: transparent;
    height: 36px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #495c8a;
    align-items: center;
    padding: 0 20px;
    font-size: 12px;
  }

  // .el-popover .container header>span{
  //   display: flex;
  //   align-items: center;
  // }
  .el-popover .container header i {
    font-size: 15px;
  }

  .el-popover .container .withoutmsg {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-popover .container .wz {
    min-height: 200px;
    max-height: 400px;
    overflow: auto;
    padding: 0 20px;

    li {
      border-bottom: 1px solid #495c8a;
      padding: 10px 0;
      cursor: pointer;
    }
  }

  .el-image-viewer__wrapper {
    z-index: 9999 !important;
  }
  .tslx {
    aspect-ratio: 880 / 376;
    background: url('../static/tslx.png') no-repeat;
    background-size: 100% 100%;
  }

  #websocketDialog {
    .el-dialog {
      position: relative;
      width: 92vw !important;
      height: 90vh !important;
      border: 2px solid #f94757;
      background-color: rgba(19, 37, 67, 0.9);
      box-shadow: 0 0 10px #f94757 inset;
      padding-bottom: 0;
      margin-top: 4vh !important;
      overflow: hidden;
      .el-dialog__header {
        padding: 0 20px;
        height: 40px;
        background-image: linear-gradient(to right, rgba(150, 36, 52, 0.82), transparent);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-dialog__title {
          font-size: 16px;
          font-weight: 600;
        }
        .el-dialog__headerbtn {
          position: static;
          width: 20px;
          height: 20px;
          line-height: 20px;
          border-radius: 50%;
          background-color: #f94757;
          overflow: hidden;
          i {
            font-size: 16px;
            vertical-align: middle;
            color: #132543;
          }
        }
      }
      .el-dialog__body {
        padding: 8px 24px 16px 24px;
        height: calc(100% - 40px);
        .left,
        .right {
          width: 35px;
        }
        .top,
        .bottom {
          position: absolute;
          width: 55px;
        }
        .bottom,
        .right {
          transform: rotate(180deg);
        }
        .top {
          top: 0;
          left: calc((384px - 55px) / 2);
        }
        .bottom {
          bottom: 0;
          left: calc((384px - 55px) / 2);
        }
        .rightBorder {
          position: absolute;
          right: -16px;
          top: 0;
          width: 35px;
          height: 100%;
          display: flex;
          align-items: center;
        }
        .leftBorder {
          position: absolute;
          left: -16px;
          top: 0;
          width: 35px;
          height: 100%;
          display: flex;
          align-items: center;
        }
        .topLines {
          height: 40px;
          border-bottom: 1px dotted #85344d;
          position: relative;
          .line1 {
            display: block;
            width: 97%;
            height: 2px;
            background-color: #85344d;
          }
          .line2 {
            display: block;
            height: 2px;
            width: 97%;
            background-color: #f94757;
            margin-top: 2px;
          }
          .line3 {
            display: block;
            height: 2px;
            width: 12%;
            background-color: #f94757;
            position: absolute;
            right: 3%;
          }
          .part {
            position: absolute;
            display: block;
            width: 8px;
            height: 8px;
            background-color: #572d48;
            right: 0;
            top: 0;
          }
          span {
            display: flex;
            height: 32px;
            align-items: center;
            color: #f94757;
            font-size: 16px;
          }
          svg {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
        }
        .mainBox {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          height: calc(100% - 40px);
          padding-top: 10px;
          .leftMap {
            width: calc(72% - 20px);
            height: 100%;
            text-align: center;
            display: flex;
            flex-flow: column nowrap;
            .topBox {
              .box {
                width: 100%;
              }
              .device_img {
                width: 100%;
                height: 100%;
                float: left;
                text-align: center;
                .close_carousel {
                  position: absolute;
                  right: 10px;
                  top: 10px;
                  color: #fff;
                  display: inline-block;
                  width: 20px;
                  height: 20px;
                  line-height: 20px;
                  text-align: center;
                  border-radius: 10px;
                  background: rgba(204, 204, 204, 0.4);
                  z-index: 9999;
                  cursor: pointer;
                }
                .close_carousel:hover {
                  background: rgba(204, 204, 204, 0.8);
                }
                .img_wrapper {
                  margin: auto;
                  vertical-align: middle;
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  img {
                    width: 100%;
                    height: auto;
                    align-items: center;
                    vertical-align: middle;
                  }
                }
              }
            }
            .bottomBox {
              width: 100%;
              height: 28%;
              display: flex;
              flex-flow: row nowrap;
              justify-content: space-between;
              margin: 10px 0;
              div {
                width: 300px;
                height: 200px;
                text-align: center;
                video {
                  width: 300px;
                  height: 180px;
                }
                img {
                  width: 200px;
                  height: 160px;
                  margin: 10px 0;
                }
                p {
                  text-align: center;
                  color: #ccc;
                }
              }
              .d3_model {
                div {
                  width: 300px;
                  height: 180px;
                }
              }
            }
          }
          .rightMsg {
            width: 28%;
            margin: 0 0 0 20px;
            height: 100%;
            font-size: 16px;
            .message {
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 56%;
              .picMsg {
                width: 100%;
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
              }
              .msg {
                text-align: justify;
                color: #fff;
                width: calc(100% - 100px);
                font-size: 16px;
              }
              .op {
                align-items: center;
                margin: auto 0 0 0;
                width: 100%;
              }
              .msg_handle {
                display: flex;
                flex-flow: column nowrap;
                margin: 20px 0 20px 0;
                width: 100%;
                justify-content: center;
                text-align: center;
                span {
                  width: 120px;
                  height: 40px;
                  margin: 10px auto;
                  line-height: 40px;
                  text-align: center;
                  color: #fff;
                  font-weight: 600;
                  font-size: 16px;
                  background-image: linear-gradient(
                    rgba(13, 215, 141, 0.64),
                    transparent,
                    rgba(13, 215, 141, 0.64)
                  );
                  border-radius: 6px;
                  // background: #306ac9;
                  cursor: pointer;
                }
                span:hover {
                  background-image: linear-gradient(
                    rgba(13, 215, 141, 0.82),
                    rgba(13, 215, 141, 0.32),
                    rgba(13, 215, 141, 0.82)
                  );
                }
              }

              .chuli:first-child {
                width: 100%;
                text-align: center;
                line-height: 30px;
              }
              .chuli:last-child {
                width: 100%;
                text-align: center;
                line-height: 30px;
              }
              svg {
                width: 18px;
                height: 18px;
              }
            }
            .monitor {
              height: calc(44% - 20px);
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 20px 0 0 0;
              color: #fff;
            }
          }
        }
      }
    }
  }

  .anchorBL {
    display: none !important;
  }

  .tabTheme {
    margin-top: 18px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue